module.exports = __webpack_public_path__ + "static/media/np.4211aa60.svg";